import { Component, OnInit, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';

declare var i18nVS: any;
declare var formularioAction: any;
declare var busquedaTarjeta: any;
declare var studentDesktopNamespace: any;
declare var addIkhlasCard: any;
declare var userData: any;
declare var isSignedIn: any;
declare var checkIkhlasCard: any;
declare var topUpAvailablesCitiesListJson: any;
declare var idCiudadLiferay: any;

@Component({
	selector: 'app-new-card',
	templateUrl: './new-card.component.html',
	styles: ['../student-desktop.component.css']
})

export class NewCardComponent implements OnInit {
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('ikhlasAddForm') ikhlasAddFormElement;    
    
    i18nL = i18nVS;    
    tipoIkhlas;
    tipoEstudiante;    
    actionForm;    
    addIkhlasCard;
    okIkhlas;    
    checkIklas;    
    user;
        
    warningNotAddIkhlas = false;
    
    ikhlasRadio = "radioIkhlas";
    estudianteRadio = "radioEstudiante";
    
    //codigoTarjetaIkhlas;
    
    namespacePortlet = studentDesktopNamespace;
    
    newNumCard;
    
    // Lista de ciudades disponibles para hacer recargas
    topUpAvailablesCitiesList = null;
    
    // Si ya tenemos una tarjeta de estudiante no se debe poder solicitar una nueva
    showGetStudentCard = false;
    
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    public ikhlasCardSelected () {
        this.tipoIkhlas = true;
        this.tipoEstudiante = false;
    }
    
    public estudianteCardSelected () {
        this.tipoEstudiante = true;
        this.tipoIkhlas = false;
    }
    
    public isTopupAvailableInCity(){
        return this.topUpAvailablesCitiesList.indexOf(idCiudadLiferay) > -1;
    }
    
    public insertIkhlasCard($event) {
        this.warningNotAddIkhlas = false;
        var codigoTarjetaIkhlas = (<HTMLSelectElement>document.getElementById(this.namespacePortlet + 'ikhlasCode')).value.toString();
        
        // se comprueba si el codigo de tarjeta introducido ya existe
        var llamadaCheckNumCard = (checkIkhlasCard + "&" + this.namespacePortlet + "ikhlasCardNum=" + codigoTarjetaIkhlas).toString();
        
        $event.preventDefault();
        console.log("Lanzando el chekeo de Tarjeta");
        this.ajaxRequest.get(llamadaCheckNumCard, new Map<string, string>()).subscribe(
        	res => { this.validateJSONcheckIkhlasCardNum(res, llamadaCheckNumCard) },
            (err) => this.errorEnElJsonCheckIkhlasCardNum(err, llamadaCheckNumCard)
        );

        return false;	// se impide el submit   
    }
	
	private validateJSONcheckIkhlasCardNum(res: Response, url: string) {
        try {
            this.newNumCard = res.json();
            
            if (!this.newNumCard) {
                //Guardar lar tarjeta
                console.log("Lanzando El guardado de la nueva tarjeta");
                this.ikhlasAddFormElement.nativeElement.submit();
        	} else {
        		this.warningNotAddIkhlas = true;
        	}
        } catch (error) {
            console.log(res);
            this.errorEnElJson("Error parseando el json", url);
        }
	}
	
	private errorEnElJsonCheckIkhlasCardNum(err: string, url: string) {
        console.log('Error en la llamada: ' + err);
        console.log(url);
        this.onWebServiceError.emit(true);
	}
    
    /**
     * Procesa errores detectados en el formato JSON
     */
    private errorEnElJson(err: string, url: string){
        console.log('Error en la llamada: ' + err);
        console.log(url);
        this.onWebServiceError.emit(true);
    }
    
    public checkAddIkhlas() {
        this.checkIklas = this.okIkhlas;
        
        if (this.checkIklas._body === "true") {
            console.log("La nueva tarjeta ikhlas se ha insertado");            
            this.warningNotAddIkhlas = false;
            (<HTMLSelectElement>document.getElementById(this.namespacePortlet + 'ikhlasCode')).value = "";
        } else {
            console.log("La tarjeta ikhlas no se ha insertado");
            this.warningNotAddIkhlas = true;
        }
                
        this.checkIklas = null;
    }
    
    /* Detectar si hay un usuario activo */
    public checkUser() {
        try {
            this.user = JSON.parse(userData);
        } catch(err) {
            console.log("Error parseando user JSON [" + err + "]");
            this.user = null;
        }   
    }
    
    // Solo se mostrara si el usuario no tiene ya una tarjeta de tipo estudiante
    public showGetNewStudentCard(res) {
    	try {
            var listaTarjetas = res.json();
	    	var yaTieneTarjetaStudent = false;
	    	for (var i = 0; i < listaTarjetas.length; i++) {
	    		if (listaTarjetas[i].cardType.description != 'IKHLAS') {
	    			yaTieneTarjetaStudent = true;
	    		}
	    	}
	    	this.showGetStudentCard = !yaTieneTarjetaStudent;
        } catch(err) {

        }
    }
    
    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {       
        this.tipoIkhlas = false;
        this.tipoEstudiante = false;
        
        this.actionForm = formularioAction;
        this.addIkhlasCard = addIkhlasCard;
        this.checkUser();
        
        this.namespacePortlet = studentDesktopNamespace;
        try {
            this.topUpAvailablesCitiesList = JSON.parse(topUpAvailablesCitiesListJson);
        } catch(err) {
            this.topUpAvailablesCitiesList = new Array();
        }
    }
    
    constructor(@Inject(Http) private ajaxRequest) { }
}



// WEBPACK FOOTER //
// ./src/app/new-card/new-card.component.ts